import { environment } from "../environments/environment";

export const API_BASE_URL = environment.apiBaseUrl;
